function f(e, n) {
  for (var t = -1, h = n.length, r = e.length; ++t < h; )
    e[r + t] = n[t];
  return e;
}
var l = f;
export {
  l as default
};
//# sourceMappingURL=_arrayPush.js.map
